import SubpageContainer from 'components/containers/subpage.container';
import { selectGroup } from 'pages/users/heat-maps/groups/heat-maps-groups.slice';
import HeatmapHeader from 'pages/users/heat-maps/heat-maps.header';
import HeatmapImage from 'pages/users/heat-maps/images/heat-maps-image';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks';

const HeatMapsUploads = () => {
  const { docs: groups } = useAppSelector(selectGroup);
  const navigate = useNavigate();
  const { id } = useParams();

  const group = groups?.find((g) => g._id === id);

  return (
    <SubpageContainer title="">
      <HeatmapHeader title={group?.name} buttonLabel="Upload" handleAction={() => navigate('new')} />
      <HeatmapImage />
    </SubpageContainer>
  );
};

export default HeatMapsUploads;
